module.exports = __webpack_public_path__ + "static/media/AboutPanel.a8ea8270.md";